import {cn} from "@/lib/utils";
import SectionPage from "@/components/common/section-page";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"

interface IllustratedTitleCardProps {
    title: string;
    description: string;
    className?: string;
    middleBreadcrumbs?: {
        title: string,
        link: string
    }[]
}

export default function EspaceProTitleCard({title, description, className, middleBreadcrumbs}: IllustratedTitleCardProps) {
    return (
        <div className={cn("w-full py-16 bg-espaceProContentHeader bg-cover text-white", className)}>
            <SectionPage sectionType={"md"} className={"flex flex-col gap-4 px-8"}>
                <h2 className="font-playfair-display text-[42px] italic font-bold ">{title}</h2>

                <Breadcrumb>
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <BreadcrumbLink className={"font-bold text-white/50"} href="/">Accueil</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator className={"font-bold text-white/50"} />
                        <BreadcrumbItem>
                            <BreadcrumbLink className={"font-bold text-white/50"} href="/espace-pro">Espace Pro</BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator className={"font-bold text-white/50"} />
                        {middleBreadcrumbs?.map(item => (
                            <>
                                <BreadcrumbItem>
                                    <BreadcrumbLink className={"font-bold text-white/50"} href={item.link}>{item.title}</BreadcrumbLink>
                                </BreadcrumbItem>
                                <BreadcrumbSeparator className={"font-bold text-white/50"} />
                            </>
                        ))}
                        <BreadcrumbItem>
                            <BreadcrumbPage className={"font-bold text-white"}>{title}</BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>


                <p className="text-xl font-roboto-light font-thin">{description}</p>
            </SectionPage>
        </div>
    );
}
